import React from "react";
import { HStack } from "@design-system/HStack/HStack";
import { Transaction } from "@common/types/transaction";
import { TransactionAmount } from "../TransactionAmount";
import { TransactionStatus } from "../TransactionStatus";

interface TransactionDetailsHeaderProps {
    transaction: Transaction;
    isLocked?: boolean;
}

export const TransactionDetailsHeader: React.FC<
    TransactionDetailsHeaderProps
> = ({ transaction, isLocked = false }) => (
    <div>
        <HStack justify="between" align="start">
            <div className="transaction-details__description-container">
                <TransactionStatus
                    transaction={transaction}
                    className="mr-2"
                    isLocked={isLocked}
                />
                <div
                    className="transaction-details__description"
                    data-testid="transaction-details-description"
                >
                    {transaction.displayDescription ??
                        transaction.bankDescription}
                </div>
            </div>
        </HStack>

        <TransactionAmount
            transaction={transaction}
            color
            addSign
            className="transaction-amount"
        />
    </div>
);
